// AlphabetFilter.js - Alphabet Filter Component with Search
// Used in Activities, Daily Logs, Food Menu modules

import React, { useState } from 'react';

const AlphabetFilter = ({ onFilterChange, className = "" }) => {
  const [activeFilter, setActiveFilter] = useState('all');
  const [searchTerm, setSearchTerm] = useState('');

  const alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');

  const handleAlphabetClick = (letter) => {
    setActiveFilter(letter);
    setSearchTerm('');
    onFilterChange({ type: 'alphabet', value: letter });
  };

  const handleShowAll = () => {
    setActiveFilter('all');
    setSearchTerm('');
    onFilterChange({ type: 'all', value: '' });
  };

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    setActiveFilter('search');
    
    // Debounce search
    if (value.length >= 2 || value.length === 0) {
      onFilterChange({ type: 'search', value });
    }
  };

  return (
    <div className={`alphabet-filter-container ${className}`}>
      {/* Search Bar */}
      <div className="search-bar mb-3">
        <div className="relative">
          <input
            type="text"
            value={searchTerm}
            onChange={handleSearchChange}
            placeholder="🔍 Cari nama kanak-kanak..."
            className="w-full px-4 py-2 pl-10 border-2 border-purple-200 rounded-lg focus:outline-none focus:border-purple-500"
          />
          {searchTerm && (
            <button
              onClick={() => {
                setSearchTerm('');
                handleShowAll();
              }}
              className="absolute right-3 top-2 text-gray-400 hover:text-gray-600"
            >
              ✕
            </button>
          )}
        </div>
      </div>

      {/* Alphabet Buttons */}
      <div className="alphabet-buttons">
        <div className="flex flex-wrap gap-1 items-center">
          <button
            onClick={handleShowAll}
            className={`px-3 py-1 rounded-md text-sm font-medium transition-all ${
              activeFilter === 'all'
                ? 'bg-gradient-to-r from-pink-500 to-purple-500 text-white shadow-md'
                : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
            }`}
          >
            Semua
          </button>

          {alphabet.map((letter) => (
            <button
              key={letter}
              onClick={() => handleAlphabetClick(letter)}
              className={`w-8 h-8 rounded-md text-sm font-bold transition-all ${
                activeFilter === letter
                  ? 'bg-gradient-to-br from-pink-400 to-purple-500 text-white shadow-lg scale-110'
                  : 'bg-white border border-gray-200 text-gray-700 hover:bg-purple-50 hover:border-purple-300'
              }`}
            >
              {letter}
            </button>
          ))}
        </div>
      </div>

      {/* Active Filter Display */}
      {activeFilter !== 'all' && (
        <div className="mt-2 text-sm text-gray-600">
          {activeFilter === 'search' ? (
            <span>🔍 Carian: <strong>{searchTerm}</strong></span>
          ) : (
            <span>📋 Huruf: <strong>{activeFilter}</strong></span>
          )}
          <button
            onClick={handleShowAll}
            className="ml-2 text-purple-600 hover:text-purple-800 underline"
          >
            Reset
          </button>
        </div>
      )}
    </div>
  );
};

export default AlphabetFilter;
